import React from 'react';

const Policies = () => {
  return (
    <div className="pb-[500px] md:pb-[160px] lg:pb-[300px] flex items-center justify-center bg-slate-900 p-4">
      <div className="w-full max-w-4xl mt-24 mb-24">
        <h1 className="text-3xl font-bold text-center mb-8 mt-20 text-white">Policies</h1>

        {/* Privacy Policy */}
        <section className="mb-10">
          <h2 className="text-2xl font-semibold text-white mb-2">Privacy Policy</h2>
          <p className="text-white text-justify">
            At Subai Jamiat Ahle Hadees, Andhra Pradesh, we respect your privacy and are committed to safeguarding your personal data.

            When you make a donation, we collect and store the following data: your name, email address, phone number, payment ID, donation cause, and amount. This information is securely stored and used solely for:
          </p>
          <ul className="list-disc ml-6 mt-3 text-white">
            <li>Issuing donation receipts and confirmation emails</li>
            <li>Maintaining transaction records for income tax purposes</li>
            <li>Verifying payments in case of fraudulent activity or erroneous transfers</li>
          </ul>
          <p className="text-white mt-3">
            All sensitive payment data (such as card or bank details) is handled securely by Razorpay, our trusted payment gateway provider, using encrypted transactions. We do not sell, rent, or share your data with any third parties.
          </p>
          <p className="text-lg text-gray-100 mt-4">
            For queries or data deletion requests, email us at: <span className="underline">apstateahlehadees@gmail.com</span>
          </p>
        </section>

        {/* Refund Policy */}
        <section className="mb-10">
          <h2 className="text-2xl font-semibold text-white mb-2">Refund Policy</h2>
          <p className="text-white text-justify">
            Donations made to Subai Jamiat Ahle Hadees, Andhra Pradesh are non-refundable as they are used for charitable purposes.
            However, if a transaction is made in error (e.g., duplicate payment), a refund request can be made within 7 days.
            Approved refunds will be processed within 7–10 business days to the original payment method.
          </p>
          <p className="text-lg text-gray-200 mt-2">
            Email us with transaction details at: <span className="underline">apstateahlehadees@gmail.com</span>
          </p>
        </section>

        {/* Cancellation Policy */}
        <section>
          <h2 className="text-2xl font-semibold text-white mb-2">Cancellation Policy</h2>
          <p className="text-white text-justify">
            As this is a donation-based platform, once a donation is processed, it cannot be canceled.
            For recurring donations, you may cancel future payments by emailing us at least 5 days before the next scheduled payment.
            No cancellations or changes will be entertained for one-time donations after payment confirmation.
          </p>
        </section>
      </div>
    </div>
  );
};

export default Policies;
